import { Component, HostListener, output } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'boels-login-indicator',
  imports: [TranslocoModule, FontAwesomeModule],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent {
  loginClicked = output<void>();
  protected readonly faUserSolid = faUser;

  @HostListener('click')
  onClick() {
    this.loginClicked.emit();
  }
}
